<template>
  <div class="activity">
    <div class="base-img-div">
      <img :src="imgList.base01" class="base-img" />
    </div>
    <div class="base-img-div post">
      <img :src="imgList.base02" class="base-img" />
      <img :src="imgList.btn01" class="base-img-btn btn01" @click="handleClick('top_btn_click')"/>
    </div>
    <div class="base-img-div post">
      <img :src="imgList.base03" class="base-img">
      <img :src="imgList.btn02" class="base-img-btn btn02" @click="handleClick('quote_btn_click')"/>
    </div>
    <div class="base-img-div"><img :src="imgList.base04" class="base-img" /></div>
    <div class="base-img-div"><img :src="imgList.base05" class="base-img" /></div>
    <div class="base-img-div post">
      <img :src="imgList.base06" class="base-img" />
      <img :src="imgList.btn01" class="base-img-btn btn03" @click="handleClick('bottom_btn_click')"/>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from '@@/api/center'
import { setToken, removeToken } from '@@/utils/auth'
import { sensorsTrack } from '@@/utils/sensors'
import { debounce } from '@@/utils/utils'

// 滚动埋点档位；entrance 值按需求原文（srcoll 为原文拼写）
const SCROLL_STEPS = [[25, 'srcoll_25'], [50, 'srcoll_50'], [75, 'srcoll_75'], [100, 'srcoll_100']]

const baseImgList = {
  fat: {
    "base01": "https://fat-file.huaqiu.com/group1/M00/09/06/wKgSH2qsmBKAOioKAAE7QaQKqXE221.png",
    "base02": "https://fat-file.huaqiu.com/group1/M00/09/06/wKgSH2qsmBKAL19UAAEyDpO_Bcg859.png",
    "base03": "https://fat-file.huaqiu.com/group1/M00/09/06/wKgSH2qsmBOATqgZAAFq-9K4BPw553.png",
    "base04": "https://fat-file.huaqiu.com/group1/M00/09/06/wKgSH2qsmBOAMCH-AADJuN5LMv0292.png",
    "base05": "https://fat-file.huaqiu.com/group1/M00/09/06/wKgSH2qsmBOAIb9FAABJxjLjk8k304.png",
    "base06": "https://fat-file.huaqiu.com/group1/M00/09/06/wKgSH2qsmBOAUQ8HAAHdAbUHkm8135.png",
    "btn01": "https://fat-file.huaqiu.com/group1/M00/09/06/wKgSH2qsmBOAf8CeAAAK4c3cDwA206.png",
    "btn02": "https://fat-file.huaqiu.com/group1/M00/09/06/wKgSH2qsmBOAdlVyAAAKwHJgYno907.png"
  },
  prod: {
    "base01": "https://file1.huaqiu.com/web3/M00/79/D3/wKgZPGqsl5CAV3XQAAE7QQ17lNk773.png",
    "base02": "https://file1.huaqiu.com/web3/M00/7F/95/wKgZO2rR3QWABJpSAAcV9BIE_po926.png",
    "base03": "https://file1.huaqiu.com/web3/M00/79/D8/wKgZO2qsl5GANPzCAAFq-xQCH_0761.png",
    "base04": "https://file1.huaqiu.com/web3/M00/79/D8/wKgZO2qsl5GAI117AADJuNYt4Co165.png",
    "base05": "https://file1.huaqiu.com/web3/M00/79/D3/wKgZPGqsl5GAVAXoAABJxvs1rVA535.png",
    "base06": "https://file1.huaqiu.com/web3/M00/7E/49/wKgZO2rMTCSATCPrAAmkL6ySSWw492.png",
    "btn01": "https://file1.huaqiu.com/web3/M00/79/D8/wKgZO2qsl5KAag2lAAAK4enrD4A225.png",
    "btn02": "https://file1.huaqiu.com/web3/M00/79/D8/wKgZO2qsl5KAHuSLAAAKwC8aHDI879.png"
  }
}
// 微信 JS-SDK：只在活动页引入（不放进 public/index.html，避免全站加载）
// ponytail: 现在没用到 wx API，不预置 onload/ready 回调；要调 wx.config 时再加 onload + 后端签名
const initWxSdk = () => {
  if (window.wx) return
  const script = document.createElement('script')
  script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
  script.async = true
  document.head.appendChild(script)
}

export default {
  data() {
    return {
      // 除了 fat 环境,其他都使用 prod 的图片资源
      imgList: process.env.NODE_ENV === 'fat' ? baseImgList.fat : baseImgList.prod,
      // URL 上携带的 token、hq_source（仅当前页面使用，不落缓存）
      urlParams: {},
      // 本页面独立的登录态（不走 store），供页面内后续逻辑判断
      isLogin: false,
      userInfo: {},
      // 滚动埋点已上报到的最高档位
      maxScrollStep: 0
    }
  },
  methods: {
    async handleClick(entrance) {
      // 神策埋点
      sensorsTrack('pcba_newuser_order_smt', { entrance })
      const envUrl = process.env.NODE_ENV == 'uat' ? 'uat-' : ''
      const activityUrl = encodeURIComponent(`https://${envUrl}smt.hqchip.com/quote/activity`)
      const webviewUrl = encodeURIComponent(`/pages/webView/index?url=${activityUrl}`)
      // 等 token 的登录请求出结果，避免刚进页面就点击时误判未登录
      await this.loginPromise
      // 这里是触发小程序的登录
      if (!this.isLogin) {
        // 需要去登录
        wx.miniProgram.navigateTo({
          url: `/pages/login/login?from=${webviewUrl}`,
        })
      } else {
        wx.miniProgram.navigateTo({
          url: '/pages-pcba/quote'
        })
      }
    },
    // 滚动埋点：算当前停留位置占整页高度的百分比，只上报没报过的最高档
    trackScroll() {
      const percent = ((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight) * 100
      const hit = SCROLL_STEPS.filter(([step]) => percent >= step).pop()
      if (!hit || hit[0] <= this.maxScrollStep) return
      this.maxScrollStep = hit[0]
      sensorsTrack('pcba_newuser_order_smt', { entrance: hit[1] })
    },
    // 有 token 就查用户信息，登录态只写在本页面（不依赖 store）
    async loginByToken() {
      const token = this.urlParams.token
      // 没有 token：本页按未登录处理，不动全局 token，避免误清站内已有登录
      if (!token) {
        this.isLogin = false
        this.userInfo = {}
        return false
      }
      // 拦截器（order_component/utils/request.js:45）只能从 localStorage.token /
      // cookie(auth_token) 取 Authorization，没法按请求带 header，所以先把 token 落长缓存
      localStorage.setItem('token', token)
      setToken(token)
      try {
        const res = await getUserInfo({})
        // body 是后端加密字段解密后的 JSON 字符串（同 store/orderUser.js 的处理）
        this.userInfo = res && res.suc ? (JSON.parse(res.body) || {}) : {}
      } catch (e) {
        console.error('获取用户信息失败:', e)
        this.userInfo = {}
      }
      this.isLogin = !!this.userInfo.sso_uid
      // token 无效就清掉，避免后续请求一直带着废 token
      if (!this.isLogin) {
        console.warn('URL token 登录失败，清理 token')
        localStorage.removeItem('token')
        removeToken()
      }
      return this.isLogin
    }
  },
  created() {
    // 取 URL 上的 token、hq_source（只读，不落缓存）
    const { token, hq_source } = this.$route.query
    this.urlParams = { token, hq_source }
    // 登录：URL 带 token 时查用户信息，结果写在本页面（isLogin / userInfo）
    this.loginPromise = this.loginByToken()
    // 引入微信 JS-SDK
    initWxSdk()
    // 滚动事件防抖，只记录最近一次停留位置；箭头包一层，debounce 内部用 func.apply(context)（utils.js:9）
    this.onScroll = debounce(() => this.trackScroll(), 300)
  },
  mounted() {
    // 获取路由 meta 中的 title 并更新页面标题
    const routeTitle = this.$route.meta.title
    if (routeTitle) {
      document.title = routeTitle
    }
    // 本页是顶层路由，不在 Layout 内（router/index.js:47-52），Header 不会挂载，需自行开启神策统计
    window.initAnalytics()
    // 开启 auto（$pageview 自动上报）。放页面里不放 initAnalytics：那是个通用入口，可被多处调用，
    // 而 quick('autoTrack') 没有幂等保护，放通用方法里每次调用都会补发一次 $pageview
    window.sensors.quick('autoTrack')
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>
<style lang="scss" scoped>
.activity {
  width: 100%;
  height: 100%;
}
.base-img-div {
  width: 100%;
  .base-img {
    display: block;
    // 750 宽设计稿按容器等比缩放；原来按图片固有尺寸(750px)渲染，移动端只露左半屏
    width: 100%;
    height: auto;
  }
  &.post {
    position: relative;
  }
  .base-img-btn {
    position: absolute;
    // 按钮图 360/750 = 48% 宽、居中(26%)，还原改宽度前的视觉位置；按设计稿微调 left 即可
    width: 48%;
    height: auto;
    left: 26%;
    transform: translateY(-50%);
    &.btn01 {
      top: 33%;
    }
    &.btn02 {
      top: 80%;
    } 
    &.btn03 {
      top: 95%;
    }
  }
}
</style>
